import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useLocation, useParams, withRouter } from "react-router-dom";
import { Button, ButtonGroup, Col, NavLink, Row } from "reactstrap";
import { GetLanguageString } from "../../helper/Components";

import moment from "moment";
import "react-datepicker/dist/react-datepicker.css";
import { ToastContainer } from "react-toastify";
import swal from "sweetalert";
import {
  CheckIsAdmin,
  CheckPermission,
  LoadingSpinner,
  MemberTypeConstant,
  applyClassToCharacters,
  convertUTCToLocalTime,
} from "../../../constants/const";
import { encryptStorage } from "../../../constants/EncryptStorage";
import SelectAssociatedMember from "../../ahbab/ContactFormAhbab/SelectAssociatedMember";
import { GetCustomStyles, GetSelectedLanguage } from "../../helper/Method";
import ChangePageTitle from "../../shared/ChangePageTitle";
import { addMember } from "../ApiMember";
import UpdateLetterForCounselling from "../MemberLetterForCounselling/UpdateLetterForCounselling";
import MarkRafiqToEx from "../MemberMarkEx/MarkRafiqToEx";
import UpdateMemberType from "../MemberType/UpdateMemberType";
import MoveMemberModal from "../MoveMemberModal";
import UpdateAddress from "./UpdateAddress";
import UpdateBooks from "./UpdateBooks";
import UpdateContactInfo from "./UpdateContactInfo";
import UpdateDocuments from "./UpdateDocuments";
import UpdateEducationOccupationSkill from "./UpdateEducationOccupationSkill";
import UpdateMaritalStatus from "./UpdateMaritalStatus";
import UpdateMemberInfo from "./UpdateMemberInfo";
import UpdateMemberMudarisInfo from "./UpdateMemberMudarisInfo";
import UpdateMemberPhoto from "./UpdateMemberPhoto";
import UpdateMemberResponsibility from "./UpdateMemberResponsibility";
import UpdateMemberUnit from "./UpdateMemberUnit";
import UpdatePledges from "./UpdatePledges";

const UpdateMember = ({ history }) => {
  const selectedLanguage = GetSelectedLanguage();
  const location = useLocation();
  const { t } = useTranslation();
  const [check, setCheck] = useState();
  const [markRafiqEx, setMarkRafiqExModal] = useState(false);
  const [moveMemberModal, setMoveMemberModal] = useState(false);
  const [isRafiqEx, setIsRafiqEx] = useState(null);
  const isAssociated = location.state?.isAssociated;
  const unitTypeName = encryptStorage.getItem("unitTypeName");
  const [showAssociatedMemberModal, setShowAssociatedMemberModal] =
    useState(false);

  const [imageUrl, setImageUrl] = useState(null);
  const [imageLoading, setImageLoading] = useState(false);

  const [updatedDetails, setUpdatedDetails] = useState(false);
  const [getDocuments, setGetDocuments] = useState(false);
  const unitId = location.state?.unitId;
  const [currentUnitId, setCurrentUnitId] = useState();
  const unitName = location.state?.unitName;
  const canModifyType = location.state?.canModifyType;
  const addNewRafiq = location.state?.addNewRafiq;
  const memberType = location.state?.memberType;
  const calledAs = location.state?.calledAs;
  const [loading, setLoading] = useState(false);
  const { id } = useParams();
  const [memberId, setMemberId] = useState(parseInt(id));
  const [activeTab, setActiveTab] = useState();
  const [discard, setDiscard] = useState(false);
  const canModifyPersonalInfo =
    addNewRafiq ||
    CheckPermission("CanUpdateName") ||
    CheckPermission("CanUpdateBasicInformation");
  const canUpdateBasicDetails = CheckPermission("CanUpdateBasicInformation");
  const canUpdateAddressAndContact = CheckPermission(
    "CanUpdateAddressAndContact",
  );
  const canUpdatePledgeAndDocuments = CheckPermission(
    "CanUpdatePledgeAndDocuments",
  );
  const canUpdatePhoto = CheckPermission("CanUpdatePhoto");
  const canUpdateNisaab = CheckPermission("CanUpdateNisaab");
  const canModifyResponsibility =
    addNewRafiq ||
    CheckPermission("CanModifyResponsibility") ||
    CheckPermission("CanRequestResponsibilityModification");
  const canModifyUnit =
    addNewRafiq ||
    CheckPermission("CanModifyMembersUnit") ||
    CheckPermission("CanRequestMemberModificationUnit");
  const canModifyMudaris = addNewRafiq || CheckPermission("CanModifyMudaris");
  const canShowMemberTypeTab =
    (canModifyType || addNewRafiq) && memberType !== MemberTypeConstant.Habeeb;
  const canShowResponsibilityTab =
    canModifyResponsibility && memberType !== MemberTypeConstant.Habeeb;
  const canShowMudarisTab = canModifyMudaris && memberType !== MemberTypeConstant.Habeeb;
  const canShowDocumentsTab =
    canUpdatePledgeAndDocuments && memberType !== MemberTypeConstant.Habeeb;
  const canShowPhotoTab = canUpdatePhoto && memberType !== MemberTypeConstant.Habeeb;
  const canShowNisaabTab = canUpdateNisaab && memberType !== MemberTypeConstant.Habeeb;
  const tab1 = activeTab === "tab1" ? "active" : "";
  const tab2 = activeTab === "tab2" ? "active" : "";
  const tab3 = activeTab === "tab3" ? "active" : "";
  const tab4 = activeTab === "tab4" ? "active" : "";
  const tab5 = activeTab === "tab5" ? "active" : "";
  const tab6 = activeTab === "tab6" ? "active" : "";
  const tab7 = activeTab === "tab7" ? "active" : "";
  const tab8 = activeTab === "tab8" ? "active" : "";
  const tab9 = activeTab === "tab9" ? "active" : "";
  const tab10 = activeTab === "tab10" ? "active" : "";
  const tab11 = activeTab === "tab11" ? "active" : "";
  const tab12 = activeTab === "tab12" ? "active" : "";
  const tab13 = activeTab === "tab13" ? "active" : "";
  const tab14 = activeTab === "tab14" ? "active" : "";

  const [memberValues, setMemberValues] = useState({
    birthDate: null,
    fatherName: "",
    fullName: "",
    serialNumber: "",
    regNo: "",
    joiningDate: null,
    unitNames: "",
    responsibility: "",
    age: "",
    colorCode: "",
    memberType: "",
  });

  const handleOnMoveMember = (e) => {
    const { name } = e.target;
    setCheck(name);
    setMoveMemberModal(true);
  };

  const handleMarkExRafiq = () => {
    setMarkRafiqExModal(true);
  };

  useEffect(() => {
    let defaultTab = null;

    if (canModifyPersonalInfo) {
      defaultTab = "tab1";
    } else if (canUpdateBasicDetails) {
      defaultTab = "tab2";
    } else if (canUpdateAddressAndContact) {
      defaultTab = "tab3";
    } else if (canShowMemberTypeTab) {
      defaultTab = "tab7";
    } else if (canShowMemberTypeTab) {
      defaultTab = "tab7";
    } else if (canShowResponsibilityTab) {
      defaultTab = "tab8";
    } else if (canModifyUnit) {
      defaultTab = "tab9";
    } else if (canShowMudarisTab) {
      defaultTab = "tab11";
    }

    setActiveTab((prevActiveTab) => prevActiveTab || defaultTab);
  }, [
    activeTab,
    canModifyPersonalInfo,
    canModifyUnit,
    canShowMemberTypeTab,
    canShowMudarisTab,
    canShowResponsibilityTab,
    canUpdateAddressAndContact,
    canUpdateBasicDetails,
  ]);

  useEffect(() => {
    if (memberId && imageUrl === null) {
      setImageLoading(true);
      addMember()
        .getMemberPhoto(memberId)
        .then((res) => {
          if (res.data) {
            setImageUrl("data:image/jpeg;base64," + res.data.image);
          }
          setImageLoading(false);
        })
        .catch((err) => {
          console.log(err);
          setImageLoading(false);
        });
    }
  }, [memberId, imageUrl]);

  useEffect(() => {
    setLoading(true);
    addMember()
      .GetMemberDataForDetails(memberId)
      .then((res) => {
        setMemberValues({
          ...res.data,
          birthDate: res.data.birthDate
            ? new Date(convertUTCToLocalTime(res.data.birthDate))
            : null,
          joiningDate: res.data.joiningDate
            ? new Date(convertUTCToLocalTime(res.data.joiningDate))
            : null,
          age:
            new Date() -
            new Date(convertUTCToLocalTime(res.data.birthDate)).getTime(),
        });
        setCurrentUnitId(res.data.unitId);
        setIsRafiqEx(res.data.isExRafiq);
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
        if (err.response?.data === "member_does_not_exist_in_hierarchy") {
          swal({
            title: t("access_denied"),
            className: GetSelectedLanguage() === "en" ? "" : "ur",
            icon: "error",
            buttons: GetSelectedLanguage() === "en" ? "OK" : "ٹھیک ہے ",
          }).then(() => {
            history.replace("/");
          });
        } else {
          swal({
            title: err,
            className: GetSelectedLanguage() === "en" ? "" : "ur",
            icon: "error",
            buttons: GetSelectedLanguage() === "en" ? "OK" : "ٹھیک ہے ",
          });
        }
        console.log(err);
      });
    // eslint-disable-next-line
  }, [memberId, updatedDetails]);

  useEffect(() => {
    if (discard) {
      if (activeTab === "tab10") {
        setGetDocuments(true);
      }
      setDiscard(!discard);
    }
  }, [activeTab, discard, setDiscard]);

  return (
    <div className="wrapper-custom wrapper wrapper-content animated fadeInRight">
      <ChangePageTitle
        pageTitle={`TI-ERP | ${
          memberValues.serialNumber !== null && memberType !== MemberTypeConstant.Habeeb
            ? memberValues.serialNumber
            : "حبیب"
        } | ${memberValues.fullName}`}
      />
      <ToastContainer
        autoClose={3000}
        bodyClassName={selectedLanguage}
        closeOnClick
        pauseOnHover={false}
        draggable
      />
      {showAssociatedMemberModal && (
        <SelectAssociatedMember
          memberHabibId={memberId}
          habibUnitId={unitId}
          setShowAssociatedMemberModal={setShowAssociatedMemberModal}
          setRefreshList={setUpdatedDetails}
          refreshList={updatedDetails}
        />
      )}
      {moveMemberModal && (
        <MoveMemberModal
          memberId={memberId}
          unitId={currentUnitId}
          check={check}
          setMoveMemberModal={setMoveMemberModal}
          setRefresh={setUpdatedDetails}
          refresh={updatedDetails}
          calledAs={
            memberType === MemberTypeConstant.Habeeb
              ? calledAs
                ? calledAs === "localHabib"
                  ? "habib"
                  : "tanzeemOrgHabib"
                : "rafiq"
              : "rafiq"
          }
        />
      )}
      {markRafiqEx ? (
        <MarkRafiqToEx
          setMarkRafiqExModal={setMarkRafiqExModal}
          memberId={memberId}
          setRefresh={setUpdatedDetails}
          refresh={updatedDetails}
        />
      ) : null}
      <Row className={GetCustomStyles().btn_style}>
        <ButtonGroup>
          <>
            {(calledAs === "localHabib"
              ? CheckPermission("CanEditAhbab")
              : CheckPermission("CanEditTanzeemOrgAhbab")) &&
            memberType === MemberTypeConstant.Habeeb ? (
              <Button
                color="primary"
                size="sm"
                onClick={() => {
                  setShowAssociatedMemberModal(true);
                }}
              >
                {isAssociated ? (
                  <GetLanguageString props="ahbab_update_associated_habib" />
                ) : (
                  <GetLanguageString props="ahbab_associate_with_habib" />
                )}
              </Button>
            ) : null}
            {CheckPermission("Ex") &&
            !isRafiqEx &&
            isRafiqEx !== null &&
            memberType !== MemberTypeConstant.Habeeb ? (
              <Button color="danger" size="sm" onClick={handleMarkExRafiq}>
                {
                  <GetLanguageString props="member_details_button_mark_rafiq_ex" />
                }
              </Button>
            ) : null}
            <div>
              {!isRafiqEx && isRafiqEx !== null ? (
                <ButtonGroup>
                  {CheckIsAdmin() ||
                  unitTypeName === "Markaz" ||
                  unitTypeName === "Zone" ||
                  unitTypeName === "ZoneOS" ? (
                    <Button
                      color="success"
                      size="sm"
                      onClick={(e) => handleOnMoveMember(e)}
                      name="admin"
                      value={unitId}
                    >
                      {
                        <GetLanguageString props="unit_unit_member_move_member" />
                      }
                    </Button>
                  ) : null}
                  {!CheckIsAdmin() &&
                  (CheckPermission("CanMoveMembersLocalTransfer") ||
                    CheckPermission("CanMoveTanzeemOrgAhbab")) &&
                  !isRafiqEx &&
                  unitTypeName !== "Markaz" &&
                  unitTypeName !== "Zone" &&
                  unitTypeName !== "ZoneOS" ? (
                    <Button
                      color="success"
                      size="sm"
                      onClick={(e) => handleOnMoveMember(e)}
                      name="Local"
                      value={unitId}
                    >
                      <GetLanguageString props="unit_unitmember_move_member_localy" />
                    </Button>
                  ) : null}
                  {!CheckIsAdmin() &&
                  (CheckPermission("CanMoveMembersOutsideTransfer") ||
                    CheckPermission("CanRequestMoveMembersOutsideTransfer") ||
                    CheckPermission("CanRequestMoveAhbab") ||
                    CheckPermission("CanRequestMoveTanzeemOrgAhbab")) &&
                  unitTypeName !== "Markaz" &&
                  unitTypeName !== "Zone" &&
                  unitTypeName !== "ZoneOS" ? (
                    <Button
                      color="info"
                      size="sm"
                      onClick={(e) => handleOnMoveMember(e)}
                      name="Outside"
                      value={unitId}
                    >
                      <GetLanguageString props="unit_unitmember_move_members_other" />
                    </Button>
                  ) : null}
                </ButtonGroup>
              ) : null}
            </div>
          </>
          <Button color="primary" size="sm" onClick={() => history.goBack()}>
            {<GetLanguageString props="courses_participants_back" />}
          </Button>
        </ButtonGroup>
      </Row>
      <br></br>
      <br></br>
      <>
        <div
          className="ibox-content"
          style={{
            backgroundColor: "#264058",
            color: "white",
            opacity: 0.8,
            borderBottom: `8px solid ${memberValues.colorCode}`,
          }}
        >
          {!loading ? (
            <Row>
              {imageLoading ? (
                <Col md="2" className="responsive-image-col">
                  {LoadingSpinner()}
                </Col>
              ) : (
                imageUrl && (
                  <Col md="2" className="responsive-image-col">
                    <img
                      style={{ height: 180 }}
                      src={imageUrl}
                      className="responsive-image"
                      alt="Uploaded"
                    />
                  </Col>
                )
              )}
              <Col md={imageUrl || imageLoading ? "3" : "4"}>
                <Row>
                  <h2 style={{ fontSize: "40px" }}>
                    {applyClassToCharacters(memberValues.fullName, "ur")}
                  </h2>
                </Row>
                <Row>
                  <h3
                    style={
                      selectedLanguage === "ur"
                        ? { fontSize: "20px", fontWeight: "lighter" }
                        : null
                    }
                  >
                    {<GetLanguageString props="member_fathers_name" />} :{" "}
                    <span
                      style={{ fontSize: "20px", fontWeight: "lighter" }}
                      className="ur"
                    >
                      {applyClassToCharacters(memberValues.fatherName, "ur")}
                    </span>{" "}
                  </h3>
                </Row>
                <Row>
                  <h3
                    style={
                      selectedLanguage === "ur"
                        ? { fontSize: "20px", fontWeight: "lighter" }
                        : null
                    }
                  >
                    {<GetLanguageString props="unit_unit_table" />} :{" "}
                    <span
                      style={{ fontSize: "20px", fontWeight: "lighter" }}
                      className="ur"
                    >
                      {memberValues.unitNames.replace(/،/g, " / ")}
                    </span>
                  </h3>
                </Row>
              </Col>
              <Col md={imageUrl || imageLoading ? "3" : "4"}>
                <Row className="text-center">
                  <h3 style={{ fontSize: "30px", unicodeBidi: "plaintext" }}>
                    {memberValues.regNo}
                  </h3>
                </Row>
                {memberType !== MemberTypeConstant.Habeeb ? (
                  <Row className="text-center">
                    <h3
                      style={
                        selectedLanguage === "ur"
                          ? { fontSize: "20px", fontWeight: "lighter" }
                          : null
                      }
                    >
                      {<GetLanguageString props="member_registration_date" />} :{" "}
                      {memberValues.joiningDate
                        ? moment(
                            convertUTCToLocalTime(memberValues.joiningDate),
                          ).format("DD/MM/yyyy")
                        : "-"}
                    </h3>
                  </Row>
                ) : (
                  <Row className="text-center">
                    <h3
                      style={
                        selectedLanguage === "ur"
                          ? { fontSize: "20px", fontWeight: "lighter" }
                          : null
                      }
                    >
                      {
                        <GetLanguageString props="meeting_members_member_type" />
                      }{" "}
                      : <span className="ur">{memberValues.memberType}</span>
                    </h3>
                  </Row>
                )}
              </Col>
              <Col md="4">
                <div className={GetCustomStyles().btn_style}>
                  {memberType !== MemberTypeConstant.Habeeb ? (
                    memberValues.responsibility !== "،" ? (
                      <Row>
                        <h3
                          style={
                            selectedLanguage === "ur"
                              ? { fontSize: "20px", fontWeight: "lighter" }
                              : null
                          }
                        >
                          {<GetLanguageString props="member_responsibility" />}{" "}
                          :{" "}
                          <span
                            style={{ fontSize: "20px", fontWeight: "lighter" }}
                            className="ur"
                          >
                            <ol
                              className="breadcrumb"
                              style={{
                                backgroundColor: "#264058",
                              }}
                            >
                              {memberValues.responsibility
                                .split("،")
                                ?.map((item, index) => {
                                  return (
                                    <li
                                      style={{
                                        backgroundColor: "#264058",
                                      }}
                                      className={
                                        GetSelectedLanguage() === "ur"
                                          ? "breadcrumb-item-ur"
                                          : "breadcrumb-item"
                                      }
                                      key={index}
                                    >
                                      <span style={{ color: "white" }}>
                                        {item}
                                      </span>
                                    </li>
                                  );
                                })}
                            </ol>
                          </span>
                        </h3>
                      </Row>
                    ) : null
                  ) : null}
                  <Row>
                    <h3
                      style={
                        selectedLanguage === "ur"
                          ? { fontSize: "20px", fontWeight: "lighter" }
                          : null
                      }
                    >
                      {<GetLanguageString props="member_date_of_birth" />} :{" "}
                      {memberValues.birthDate
                        ? moment(
                            convertUTCToLocalTime(memberValues.birthDate),
                          ).format("DD/MM/yyyy")
                        : "-"}
                    </h3>
                  </Row>
                  {memberValues.birthDate ? (
                    <Row>
                      <h3
                        style={
                          selectedLanguage === "ur"
                            ? { fontSize: "20px", fontWeight: "lighter" }
                            : null
                        }
                      >
                        {<GetLanguageString props="member_age" />} :{" "}
                        {new Date(memberValues.age).getUTCFullYear() - 1970}
                      </h3>
                    </Row>
                  ) : null}
                </div>
              </Col>
            </Row>
          ) : (
            LoadingSpinner()
          )}
        </div>

        <br></br>
        <Row>
          <Col md="12">
            <div className="tabs-container">
              <ul className="nav nav-tabs" role="tablist">
                {canModifyPersonalInfo ? (
                  <li>
                    <NavLink
                      to="#"
                      className={"nav-link " + tab1}
                      onClick={() => {
                        setActiveTab("tab1");
                      }}
                    >
                      {memberType !== MemberTypeConstant.Habeeb ? (
                        <GetLanguageString props="member_member_detail" />
                      ) : (
                        <GetLanguageString props="ahbab_transfer_habib_habib_details" />
                      )}
                    </NavLink>
                  </li>
                ) : null}
                {memberType !== MemberTypeConstant.Habeeb ? (
                  <>
                    {canUpdateBasicDetails ? (
                      <>
                        <li>
                          <NavLink
                            to="#"
                            className={"nav-link " + tab2}
                            onClick={() => {
                              setActiveTab("tab2");
                            }}
                          >
                            {
                              <GetLanguageString props="member_marital_status" />
                            }
                          </NavLink>
                        </li>
                        <li>
                          <NavLink
                            to="#"
                            className={"nav-link " + tab5}
                            onClick={() => {
                              setActiveTab("tab5");
                            }}
                          >
                            <GetLanguageString
                              props={
                                memberType !== MemberTypeConstant.Habeeb
                                  ? "member_education_occupatoin_skills"
                                  : "member_education_occupatoin"
                              }
                            />
                          </NavLink>
                        </li>
                      </>
                    ) : null}
                    {canShowDocumentsTab ? (
                      <li>
                        <NavLink
                          to="#"
                          className={"nav-link " + tab10}
                          onClick={() => {
                            setGetDocuments(true);
                            setActiveTab("tab10");
                          }}
                        >
                          {
                            <GetLanguageString props="member_member_detail_documents" />
                          }
                        </NavLink>
                      </li>
                    ) : null}
                  </>
                ) : null}
                {canUpdateAddressAndContact ? (
                  <li>
                    <NavLink
                      to="#"
                      className={"nav-link " + tab3}
                      onClick={() => {
                        setActiveTab("tab3");
                      }}
                    >
                      {<GetLanguageString props="member_address" />}
                    </NavLink>
                  </li>
                ) : null}
                {canUpdateAddressAndContact ? (
                  <li>
                    <NavLink
                      to="#"
                      className={"nav-link " + tab4}
                      onClick={() => {
                        setActiveTab("tab4");
                      }}
                    >
                      <GetLanguageString props="member_contact" />
                    </NavLink>
                  </li>
                ) : null}

                {memberType !== MemberTypeConstant.Habeeb ? (
                  <>
                    {canShowPhotoTab ? (
                      <li>
                        <NavLink
                          to="#"
                          className={"nav-link " + tab6}
                          onClick={() => {
                            setActiveTab("tab6");
                          }}
                        >
                          <GetLanguageString props="member_photo" />
                        </NavLink>
                      </li>
                    ) : null}
                    {canShowNisaabTab ? (
                      <li>
                        <NavLink
                          to="#"
                          className={"nav-link " + tab13}
                          onClick={() => {
                            setActiveTab("tab13");
                          }}
                        >
                          {
                            <GetLanguageString props="member_member_detail_books" />
                          }
                        </NavLink>
                      </li>
                    ) : null}
                    <li>
                      <NavLink
                        to="#"
                        className={"nav-link " + tab14}
                        onClick={() => {
                          setActiveTab("tab14");
                        }}
                      >
                        {
                          <GetLanguageString props="member_member_detail_letter_for_counselling" />
                        }
                      </NavLink>
                    </li>
                    {canUpdatePledgeAndDocuments ? (
                      <li>
                        <NavLink
                          to="#"
                          className={"nav-link " + tab12}
                          onClick={() => {
                            setActiveTab("tab12");
                          }}
                        >
                          {
                            <GetLanguageString props="member_member_detail_pledges" />
                          }
                        </NavLink>
                      </li>
                    ) : null}
                  </>
                ) : null}
                {canShowMudarisTab ? (
                  <li>
                    <NavLink
                      to="#"
                      className={"nav-link " + tab11}
                      onClick={() => {
                        setActiveTab("tab11");
                      }}
                    >
                      <GetLanguageString props="member_member_detail_mudaris" />
                    </NavLink>
                  </li>
                ) : null}
                {canShowMemberTypeTab ? (
                  <li>
                    <NavLink
                      to="#"
                      className={"nav-link " + tab7}
                      onClick={() => {
                        setActiveTab("tab7");
                      }}
                    >
                      <GetLanguageString props="meeting_members_member_type" />
                    </NavLink>
                  </li>
                ) : null}
                {canShowResponsibilityTab ? (
                  <li>
                    <NavLink
                      to="#"
                      className={"nav-link " + tab8}
                      onClick={() => {
                        setActiveTab("tab8");
                      }}
                    >
                      <GetLanguageString props="member_member_detail_common_responsibility" />
                    </NavLink>
                  </li>
                ) : null}
                {canModifyUnit ? (
                  <li>
                    <NavLink
                      to="#"
                      className={"nav-link " + tab9}
                      onClick={() => {
                        setActiveTab("tab9");
                      }}
                    >
                      <GetLanguageString props="courses_unit" />
                    </NavLink>
                  </li>
                ) : null}
              </ul>
              <div className="tab-content">
                {canModifyPersonalInfo ? (
                  <UpdateMemberInfo
                    tab1={tab1}
                    memberId={memberId}
                    addNewRafiq={addNewRafiq}
                    setMemberId={setMemberId}
                    setUpdatedDetails={setUpdatedDetails}
                    updatedDetails={updatedDetails}
                    memberType={memberType}
                    activeTab={activeTab}
                    setActiveTab={setActiveTab}
                    discard={discard}
                    setDiscard={setDiscard}
                  />
                ) : null}
                {canUpdateBasicDetails ? (
                  <>
                    <UpdateMaritalStatus
                      tab2={tab2}
                      memberId={memberId}
                      addNewRafiq={addNewRafiq}
                      activeTab={activeTab}
                      setActiveTab={setActiveTab}
                      setDiscard={setDiscard}
                      discard={discard}
                    />
                    <UpdateEducationOccupationSkill
                      tab5={tab5}
                      memberId={memberId}
                      addNewRafiq={addNewRafiq}
                      activeTab={activeTab}
                      setActiveTab={setActiveTab}
                      discard={discard}
                      setDiscard={setDiscard}
                      memberType={memberType}
                    />
                  </>
                ) : null}
                {canUpdateAddressAndContact ? (
                  <UpdateAddress
                    tab3={tab3}
                    memberId={memberId}
                    addNewRafiq={addNewRafiq}
                    setUpdatedDetails={setUpdatedDetails}
                    memberType={memberType}
                    activeTab={activeTab}
                    setActiveTab={setActiveTab}
                    setDiscard={setDiscard}
                  />
                ) : null}
                {canUpdateAddressAndContact ? (
                  <UpdateContactInfo
                    tab4={tab4}
                    memberId={memberId}
                    addNewRafiq={addNewRafiq}
                    memberType={memberType}
                    activeTab={activeTab}
                    setActiveTab={setActiveTab}
                    setDiscard={setDiscard}
                  />
                ) : null}

                {canShowPhotoTab ? (
                  <UpdateMemberPhoto
                    tab6={tab6}
                    memberId={memberId}
                    addNewRafiq={addNewRafiq}
                    setImageUrlForDetails={setImageUrl}
                    imageUrl={imageUrl}
                    activeTab={activeTab}
                    discard={discard}
                    setDiscard={setDiscard}
                  />
                ) : null}
                {canShowNisaabTab ? (
                  <UpdateBooks
                    tab13={tab13}
                    memberId={memberId}
                    discard={discard}
                    setDiscard={setDiscard}
                    activeTab={activeTab}
                    setActiveTab={setActiveTab}
                  />
                ) : null}
                {canShowDocumentsTab ? (
                  <UpdateDocuments
                    tab10={tab10}
                    memberId={memberId}
                    getDocuments={getDocuments}
                    discard={discard}
                    setDiscard={setDiscard}
                    activeTab={activeTab}
                    setActiveTab={setActiveTab}
                  />
                ) : null}
                {canUpdatePledgeAndDocuments ? (
                  <UpdatePledges
                    tab12={tab12}
                    memberId={memberId}
                    setDiscard={setDiscard}
                    activeTab={activeTab}
                    discard={discard}
                  />
                ) : null}
                <UpdateLetterForCounselling
                  tab14={tab14}
                  activeTab={activeTab}
                  memberId={memberId}
                  discard={discard}
                  setDiscard={setDiscard}
                  memberValues={{
                    memberName: memberValues.fullName,
                    memberResponsibility: memberValues.responsibility,
                    memberRegNo: memberValues.regNo,
                    memberUnit: memberValues.unitNames,
                  }}
                />
                {canShowMemberTypeTab ? (
                  <UpdateMemberType
                    tab7={tab7}
                    memberId={memberId}
                    addNewRafiq={addNewRafiq}
                    setUpdatedDetails={setUpdatedDetails}
                    activeTab={activeTab}
                    setActiveTab={setActiveTab}
                    discard={discard}
                    setDiscard={setDiscard}
                  />
                ) : null}
                {canShowResponsibilityTab ? (
                  <UpdateMemberResponsibility
                    tab8={tab8}
                    memberId={memberId}
                    unitId={unitId}
                    unitName={unitName}
                    addNewRafiq={addNewRafiq}
                    setUpdatedDetails={setUpdatedDetails}
                    discard={discard}
                    setDiscard={setDiscard}
                    activeTab={activeTab}
                    setActiveTab={setActiveTab}
                    memberType={memberType}
                  />
                ) : null}
                {canModifyUnit ? (
                  <UpdateMemberUnit
                    tab9={tab9}
                    memberId={memberId}
                    addNewRafiq={addNewRafiq}
                    setUpdatedDetails={setUpdatedDetails}
                    memberType={memberType}
                    activeTab={activeTab}
                    setActiveTab={setActiveTab}
                    setDiscard={setDiscard}
                  />
                ) : null}
                {canShowMudarisTab ? (
                  <UpdateMemberMudarisInfo
                    tab11={tab11}
                    editValue={memberId}
                    refresh={updatedDetails}
                    setRefresh={setUpdatedDetails}
                    activeTab={activeTab}
                    setActiveTab={setActiveTab}
                    setDiscard={setDiscard}
                    discard={discard}
                  />
                ) : null}
              </div>
            </div>
          </Col>
        </Row>
      </>
    </div>
  );
};

export default withRouter(UpdateMember);
